export default function TaskFilters({
 filters,
 setFilters,
 tasks,
}) {


const update = (key,value)=>{

 setFilters({
  ...filters,
  [key]:value
 });

};


const users = [
 ...new Set(
  tasks
   .map(t=>t.assigned_to)
   .filter(Boolean)
 )
];


return (

<div
className="
bg-[#1a1d24]
border
border-slate-800
rounded-2xl
p-4
mb-6
"
>


<div className="
grid
grid-cols-1
md:grid-cols-5
gap-3
">


<input
placeholder="Search..."
value={filters.search}
onChange={(e)=>
 update("search",e.target.value)
}
className="
bg-[#111318]
border
border-slate-700
rounded-xl
px-4
py-2
"
/>


<select
value={filters.assigned_to}
onChange={(e)=>
 update("assigned_to",e.target.value)
}
className="
bg-[#111318]
border
border-slate-700
rounded-xl
px-4
py-2
"
>

<option value="all">
Everyone
</option>

{
users.map(user=>(
<option key={user} value={user}>
{user}
</option>
))
}

</select>


<select
value={filters.status}
onChange={(e)=>
 update("status",e.target.value)
}
className="
bg-[#111318]
border
border-slate-700
rounded-xl
px-4
py-2
"
>

<option value="all">
All Statuses
</option>

<option value="new">
New
</option>

<option value="in_progress">
In Progress
</option>

<option value="done">
Done
</option>

</select>



<select
value={filters.priority}
onChange={(e)=>
 update("priority",e.target.value)
}
className="
bg-[#111318]
border
border-slate-700
rounded-xl
px-4
py-2
"
>

<option value="all">
All Priorities
</option>

<option value="low">
Low
</option>

<option value="medium">
Medium
</option>

<option value="high">
High
</option>

</select>



<select
value={filters.date}
onChange={(e)=>
 update("date",e.target.value)
}
className="
bg-[#111318]
border
border-slate-700
rounded-xl
px-4
py-2
"
>

<option value="all">
All Time
</option>

<option value="today">
Today
</option>

<option value="week">
Last 7 Days
</option>

<option value="month">
Last 30 Days
</option>

</select>


</div>


</div>

)

}